export class Email {
    constructor(public email?: string) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/email.model.ts